import { Scene, SuperContainer} from "onearm";

/**
 * @class HUDScene
 * @description Pure View scene for HUD - only builds and holds layout.
 * All logic is handled by HUDController.
 */
export class HUDScene extends Scene {
    create() {
        super.create();
        this.layout = this.buildLayout("HUD");
        this.reelsPlaceholder = new SuperContainer();
        this.layout.onLayoutChange.connect(this.addReelsPlaceholder.bind(this));
        this.addReelsPlaceholder();

        this.bg = this.createObject("SpineAnimation", {
            spine: 'gool_hv_1',
            animation: "gool_hv_1",
            loop: true,
            autoPlay: true,
            x: 500,
            y: 500,
        });

        this.bg.goToStart();
    }

    /**
     * @description Get child element by name
     * @param {string} name
     * @returns {Object|null}
     */
    get(name) {
        return this.layout?.get?.(name) ?? null;
    }

    /**
     * @description Find child element by name recursively
     * @param {string} name
     * @returns {Object|null}
     */
    find(name) {
        return this.layout?.find?.(name) ?? null;
    }

    /**
     * @description Find all children matching name recursively
     * @param {string} name
     * @returns {Object[]}
     */
    findAll(name) {
        return this.layout?.findAll?.(name) ?? [];
    }

    /**
     * @description Iterate over all matching elements
     * @param {string|string[]} name
     * @param {function} callback
     */
    forAll(name, callback) {
        if (!this.layout?.forAll) return;

        if (Array.isArray(name)) {
            name.forEach(n => this.layout.forAll(n, callback));
        } else {
            this.layout.forAll(name, callback);
        }
    }

    /**
     * @description Get the reels placeholder container
     * @returns {Object|null}
     */
    getReelsPlaceholder() {
        return this.reelsPlaceholder;
    }

    addReelsPlaceholder() {
        const reelsPlaceholder = this.layout.findInCurrentLayout("ReelsPlaceholder");

        if (reelsPlaceholder) {
            reelsPlaceholder.addChild(this.reelsPlaceholder);
        }
    }
}
